import { useCallback } from "react";
import { getClientDomain, getToken } from "../utils/Common";

export const useRequests = () => {
    const getAllRequests = useCallback(async (signal) => {

        const response = await fetch(`${getClientDomain()}/requests/all`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'authorization': `Bearer ${getToken()}`
           
            },
            signal: signal,
            });      
        
            const result = await response.json();        
        
            if (result?.payload?.length > 0) {
                return result;
            } else {
                return {...result, payload: []};
            }

        }, []);

        const getListRequestsStatus = useCallback(async (signal, status) => {
            const response = await fetch(`${getClientDomain()}/requests/listStatus`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'authorization': `Bearer ${getToken()}`
           
                },
                signal: signal,
            });

            const result = await response.json();        
        
            if (Array.isArray(result?.payload) && result.payload.length > 0) {
                return result?.payload;
            } else if (result?.payload) {
                return { ...result, payload: [result.payload] };
            } else {
                return { ...result, payload: [] };
            }

        }, []);

        const searchRequests = useCallback(async (signal, data) => {
            const response = await fetch(`${getClientDomain()}/requests/search`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'authorization': `Bearer ${getToken()}`
                    ,
                },
                signal: signal,
                body: JSON.stringify(data)
            });

            const result = await response.json();        
        
            if (result?.payload?.length > 0) {
                return result;
            } else {
                return {...result, payload: []};
            }

        }, []);

        const createRequest = useCallback(async (signal, data) => {
            const response = await fetch(`${getClientDomain()}/requests/create`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'authorization': `Bearer ${getToken()}`
           
                },
                signal: signal,
                body: JSON.stringify(data)
            });

            const result = await response.json();
            if (result?.payload?.length > 0) return {...result, payload: result.payload[0]};
            else return {...result};

        }, []);

        const manageRequest = useCallback(async (signal, data) => {
            const response = await fetch(`${getClientDomain()}/requests/manage`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'authorization': `Bearer ${getToken()}`
           
                },
                signal: signal,
                body: JSON.stringify(data)
            });

            const result = await response.json();
            if (result?.payload?.length > 0) return {...result, payload: result.payload[0]};
            else return {...result};

        }, []);

        const getListTypes = useCallback(async (signal) => {
            const response = await fetch(`${getClientDomain()}/requests/listTypes`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'authorization': `Bearer ${getToken()}`
           
                },
                signal: signal,
            });

            const result = await response.json();        
        
            if (Array.isArray(result?.payload) && result.payload.length > 0) {
                return result?.payload;
            } else if (result?.payload) {
                return { ...result, payload: [result.payload] };
            } else {
                return { ...result, payload: [] };
            }

        }, []);


    return {getAllRequests, getListRequestsStatus, searchRequests, createRequest, manageRequest, getListTypes};
}
